<template>
    <div
        style="border: 1px solid #C5D0E2;border-radius: 2px;background: #FFFFFF;padding: 12px 12px 16px 20px;margin-top: 20px;">
        <div style="display: flex; align-items: center;">
            <div style="flex: 1;display: flex; align-items: center;">
                <span style="font-weight: bold;font-size: 14px;color: #0F1A3A;">{{ carNo }}</span>
                <img v-if="isRecharge" src="../../../../assets/images/icon_recharge.png"
                    style="width: 32px;height: 20px;margin-left: 4px;" />
            </div>
            <div v-if="isRecharge" style="color: #07B477;font-size: 14px;font-weight: bold;">{{ soc }}%</div>
        </div>
        <!--进度条，渐变色，动态显示-->
        <div v-if="isRecharge"
            style="width: 100%; height: 4px; background-color: transparent; border-radius: 2px; overflow: hidden;margin-top: 8px;">
            <div style="background: linear-gradient( 90deg, rgba(7,180,119,0) 1%, #07B477 100%);border-radius: 2px;"
                :style="{
                    width: `${soc}%`,
                    height: '100%',
                    transition: 'width 0.5s ease-in-out'
                }"></div>
        </div>
        <div style="margin-top: 16px;">
            <div style="display: flex; align-items: center;">
                <div style="font-size: 14px;color: #0F1A3A;">{{ $t('recharge.当前电量') }}：{{ soc }} %</div>
            </div>
            <div style="display: flex; align-items: center;margin-top: 8px;">
                <div style="font-size: 14px;color: #0F1A3A;">{{ $t('recharge.续航里程') }}：{{ mileage }} km</div>
            </div>
            <div style="display: flex; align-items: center;margin-top: 8px;">
                <!--不透明度-->
                <div style="font-size: 14px;color: #0F1A3A;opacity: 0.5;">{{ $t('recharge.总电压') }}：{{ totalVoltage }} V
                </div>
            </div>
            <div style="display: flex; align-items: center;margin-top: 8px;">
                <!--不透明度-->
                <div style="font-size: 14px;color: #0F1A3A;opacity: 0.5;">{{ $t('recharge.总电流') }}：{{ totalCurrent }} A
                </div>
            </div>
            <div style="display: flex; align-items: center;margin-top: 8px;">
                <!--不透明度-->
                <div style="font-size: 14px;color: #0F1A3A;opacity: 0.5;">{{ $t('recharge.更新时间') }}：{{ UpdateTime }}
                </div>
            </div>

            <div v-if="isRecharge" style="display: flex; align-items: center;margin-top: 8px;">
                <div style="font-size: 14px;color: #0F1A3A;">{{ $t('recharge.剩余充电时长') }}： {{ rechargeTime }} {{
                    $t('time.hour') }}</div>
                <stop-charge-dialog
                    :VehicleID="VehicleID"
                />
            </div>


        </div>


    </div>
</template>
<script>
import { controlEncrypt} from '@/utils/encrypt';
import StopChargeDialog from './stopChargeDialog.vue';
export default {
    components: {
        StopChargeDialog
    },
    props: {
        rechargeTime: {
            type: [Number, String],
            default: 0
        },
        totalCurrent: {
            type: [Number, String],
            default: 0
        },
        totalVoltage: {
            type: [Number, String],
            default: 0
        },
        mileage: {
            type: [Number, String],
            default: 0
        },
        isRecharge: {
            type: Boolean,
            default: false
        },
        carNo: {
            type: String,
            default: ''
        },
        soc: {
            type: Number,
            default: 0
        },
        VehicleID: {
            type: String,
            default: ''
        },
        UpdateTime: {
            type: String,
            default: ''
        }
    },
    data() {
        return {
        }
    },
    methods: {
    }
}
</script>
<style lang="scss" scoped></style>